/*
 *             Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.
 *
 *
 *
 *
 *          +---------------------------------------------------------------------------------+
 *          |                                                                                 |
 *          |                                 Hello stranger!                                 |
 *          |                                                                                 |
 *          |                                                                                 |
 *          |   What you're currently looking at is the source code of a legally protected,   |
 *          |    proprietary software. Any attempts to deobfuscate / disassemble this code    |
 *          |               are forbidden and will result in legal consequences.              |
 *          |                                                                                 |
 *          |                                                                                 |
 *          +---------------------------------------------------------------------------------+
 *
 *
 *
 *
 */
var _0x71d8=['requires','SlashCommand','Mention','pluginName'];(function(_0x4a18b8,_0x71d8e3){var _0x374325=function(_0x5eef89){while(--_0x5eef89){_0x4a18b8['push'](_0x4a18b8['shift']());}};_0x374325(++_0x71d8e3);}(_0x71d8,0x19b));var _0x3743=function(_0x4a18b8,_0x71d8e3){_0x4a18b8=_0x4a18b8-0x0;var _0x374325=_0x71d8[_0x4a18b8];return _0x374325;};import{Plugin as _0x1b0e11}from'ckeditor5/src/core';import _0x302a47 from'./slashcommandediting';import _0x5d3d09 from'./slashcommandui';export default class o extends _0x1b0e11{static get[_0x3743('0x1')](){return[_0x3743('0x3'),_0x302a47,_0x5d3d09];}static get[_0x3743('0x0')](){return _0x3743('0x2');}}